import React, { memo, useEffect, useState } from 'react';
import Slider from 'react-slick';
import { useWindowSize } from 'react-use';
import { DEVICES } from '@zmedia/bm-soccer-ui/constants';
import { DeviceUtils } from '@zmedia/bm-soccer-ui/utils';
import styles from './style.module.scss';

export function CustomSlider({ children, settings }: any) {
    const size = useWindowSize();
    const [isDesktop, setIsDesktop] = useState<boolean>(false);

    useEffect(() => {
        const isDesktop = DeviceUtils.getDevice() === DEVICES.DESKTOP;
        setIsDesktop(isDesktop);
    }, [size]);

    if (!isDesktop) {
        return <>{children}</>;
    }
    return (
        <Slider {...settings} className={styles['custom-slider']}>
            {children}
        </Slider>
    );
}

export default memo(CustomSlider);
